import { Workbox } from 'workbox-window'

let registration: Promise<ServiceWorkerRegistration | undefined> | null = null

export function registerPwa() {
  if (!('serviceWorker' in navigator) || registration || shouldSkipPwa()) {
    return registration
  }

  const workbox = new Workbox('/sw.js', { type: 'classic' })

  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  registration = workbox.register().catch(() => undefined)
  return registration
}

export async function unregisterPwaForAdmin() {
  if (!('serviceWorker' in navigator) || !isAdminPath()) {
    return
  }

  const registrations = await navigator.serviceWorker.getRegistrations()
  await Promise.all(registrations.map((item) => item.unregister()))
}

function shouldSkipPwa() {
  return isAdminPath()
}

function isAdminPath() {
  return window.location.pathname.startsWith('/admin')
}
